<template>
  <b-form-group
    label="Misyon Başlık"
    label-for="vision_mission_title"
  >
    <validation-provider
      #default="{ errors }"
      name="Misyon Başlık"
      rules="required"
    >
      <b-form-input
        id="vision_mission_title"
        v-model="itemData.vision_mission_title"
        placeholder="Misyon Başlık"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'VisionMissionTitle',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
}
</script>
